import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CurrentDate, UpdateSelectedDate, UpdateShowToggle } from './date.action';

export interface IDateModel {
  currentDate: Date;
  selectedDate: string;
  isShowToggle: boolean;
}

@State<IDateModel>({
  name: 'Date',
  defaults: {
    currentDate: new Date(),
    selectedDate: '',
    isShowToggle: false,
  },
})
@Injectable()
export class DateState {
  constructor() {}

  @Selector()
  public static getCurrentDate(state: IDateModel): Date {
    return state.currentDate;
  }

  public static UpdateSelectedDate(state: IDateModel): string {
    return state.selectedDate;
  }

  public static UpdateShowToggle(state: IDateModel): boolean {
    return state.isShowToggle;
  }

  @Action(CurrentDate)
  currentDate({ getState, setState }: StateContext<IDateModel>, { payload }: CurrentDate): void {
    const state = getState();
    setState({
      ...state,
      currentDate: payload,
    });
  }

  @Action(UpdateSelectedDate)
  selectedDate({ getState, setState }: StateContext<IDateModel>, { payload }: UpdateSelectedDate): void {
    const state = getState();
    setState({
      ...state,
      selectedDate: payload,
    });
  }

  @Action(UpdateShowToggle)
  ShowtoggleDate({ getState, setState }: StateContext<IDateModel>, { payload }: UpdateShowToggle): void {
    const state = getState();
    setState({
      ...state,
      isShowToggle: payload,
    });
  }
}
